/**
 * The tyres module's paths.
 *
 * `/tyres` is the fleet listing and the module's root. A workshop arrives with "which
 * tyres need replacing", not with a serial number, so the reverse nesting under a
 * vehicle would make the morning screen unreachable without first choosing a vehicle
 * nobody has identified yet — the same argument `features/maintenance/routes.ts` makes.
 *
 * Route paths stay in English while the UI defaults to French: the address bar is not a
 * translated surface, and a localized set would mean two routing tables and a redirect
 * on every language switch.
 */

export const TYRES_PATH = '/tyres'

export const TYRE_QUERY_KEYS = {
  /** `illegal` | `replace_soon` | `monitor` | `ok`. */
  verdict: 'verdict',
  /** `fitted` | `stock` | `repair` | `scrapped`. */
  status: 'status',
  vehicleId: 'vehicle',
  search: 'q',
  /** Which casing's detail panel is open, so a finding forwards as a link. */
  selected: 'tyre',
} as const

/** A deep link into one wear band — what a tile links to. */
export function tyresPath(verdict?: 'illegal' | 'replace_soon' | 'monitor' | 'ok'): string {
  return verdict === undefined ? TYRES_PATH : `${TYRES_PATH}?${TYRE_QUERY_KEYS.verdict}=${verdict}`
}

/** One vehicle's casings, as a filtered listing rather than a route of its own. */
export function vehicleTyresPath(vehicleId: string): string {
  return `${TYRES_PATH}?${TYRE_QUERY_KEYS.vehicleId}=${vehicleId}`
}

export function tyreDetailPath(tyreId: string): string {
  return `${TYRES_PATH}?${TYRE_QUERY_KEYS.selected}=${tyreId}`
}
